import { useMemo } from 'react'
import { decodeJwt } from 'jose'
import { Abruftoken } from '@/models/Abruftoken'
import { useHasDeadlinePassed } from '@repo/ui'

/**
 * Reactively returns `true` once the abruftoken's JWT `exp` claim has passed.
 * Uses a single `setTimeout` internally. no polling.
 * Accepts `null | undefined` for use before early returns (rules of hooks).
 */
export default function useIsAbruftokenExpired(
  abruftoken: Abruftoken | null | undefined
): boolean {
  const expiresAt = useMemo(() => {
    if (!abruftoken) return null
    const payload = decodeJwt(abruftoken.abruftoken)
    return payload.exp ? new Date(payload.exp * 1000) : null
  }, [abruftoken])

  return useHasDeadlinePassed(expiresAt)
}
